import { useState, useRef, useCallback } from "react";

/**
 * 群聊协作相关状态 Hook
 */
const useGroupChatState = () => {
  const [isGroupChatOpen, setIsGroupChatOpen] = useState(false);
  const [roomId, setRoomId] = useState(null);
  const [projectName, setProjectName] = useState("");
  const [currentPhase, setCurrentPhase] = useState("");
  const [phaseLabel, setPhaseLabel] = useState("");
  const [phases, setPhases] = useState([]);
  const [members, setMembers] = useState([]);
  const [agents, setAgents] = useState([]);
  const [messages, setMessages] = useState([]);
  const [streamingContent, setStreamingContent] = useState({}); // agentId -> { agentName, content }
  const [roundsInPhase, setRoundsInPhase] = useState(0);
  const [maxRounds, setMaxRounds] = useState(12);
  const [status, setStatus] = useState("idle"); // idle | creating | active | completed
  const [isWaiting, setIsWaiting] = useState(false);
  const [templateId, setTemplateId] = useState(null);
  const [myUserId, setMyUserId] = useState(""); // 当前用户 ID，用于区分自己的消息和成员高亮

  const groupChatWsRef = useRef(null);

  const resetGroupChatState = useCallback(() => {
    setRoomId(null);
    setProjectName("");
    setCurrentPhase("");
    setPhaseLabel("");
    setPhases([]);
    setMembers([]);
    setAgents([]);
    setMessages([]);
    setStreamingContent({});
    setRoundsInPhase(0);
    setMaxRounds(12);
    setStatus("idle");
    setIsWaiting(false);
    setTemplateId(null);
    setMyUserId("");
    if (groupChatWsRef.current) {
      groupChatWsRef.current.close();
      groupChatWsRef.current = null;
    }
  }, []);

  return {
    isGroupChatOpen,
    setIsGroupChatOpen,
    roomId,
    setRoomId,
    projectName,
    setProjectName,
    currentPhase,
    setCurrentPhase,
    phaseLabel,
    setPhaseLabel,
    phases,
    setPhases,
    members,
    setMembers,
    agents,
    setAgents,
    messages,
    setMessages,
    streamingContent,
    setStreamingContent,
    roundsInPhase,
    setRoundsInPhase,
    maxRounds,
    setMaxRounds,
    status,
    setStatus,
    isWaiting,
    setIsWaiting,
    templateId,
    setTemplateId,
    myUserId,
    setMyUserId,
    groupChatWsRef,
    resetGroupChatState,
  };
};

export default useGroupChatState;
